import React, { Fragment, useMemo } from "react";
import PropTypes from "prop-types";
import BWModels from "@benjamin-west-rpm2/benjamin-west-models";

import statusFormFields from "./statusFormFields";
import FormGrid from "../../../../../../components/forms/FormGrid";
import ActionButtons from "../../../../../../components/forms/ActionButtons";
import FormikForm from "../../../../../../components/forms/FormikForm";
import propTypes from "../../../../../../constants/propTypes";
import { useCreateProcessRequests } from "../../../../../hooks/useProcessRequest";

const StatusForm = ({
  onSubmit,
  loading,
  isPaid,
  funding,
  toggleShowList,
  dataComponent,
  performAfterCreatePayment,
  showSnackNotificationAction,
  timezone,
}) => {
  const initialValues = useMemo(() => {
    return { fundingId: funding.id };
  }, [funding]);

  useCreateProcessRequests(dataComponent, {
    onSuccess: () => {
      performAfterCreatePayment();
      toggleShowList();
    },
    onError: error => {
      showSnackNotificationAction(error.title);
    },
  });

  const validationSchema = useMemo(
    () => BWModels.loadSchema("FundingPayment"),
    []
  );

  const { projectCurrency } = funding;

  return (
    <FormikForm
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
    >
      {({ handleSubmit, values, errors, ...formikProps }) => (
        <Fragment>
          <FormGrid
            fields={statusFormFields(projectCurrency?.currency, timezone)}
            values={values}
            errors={errors}
            {...formikProps}
          />
          <ActionButtons
            isModal
            onSend={handleSubmit}
            onCancel={toggleShowList}
            sendButtonText="Save Payment"
            hideDangerButton={loading || isPaid}
            listeners={[dataComponent.dataComponentId]}
          />
        </Fragment>
      )}
    </FormikForm>
  );
};

StatusForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  isUpdate: PropTypes.bool,
  number: PropTypes.string,
  initialValues: propTypes.glCode,
  showSnackNotificationAction: PropTypes.func,
  toggleShowList: PropTypes.func,
  loading: PropTypes.bool,
  isPaid: PropTypes.bool,
  funding: propTypes.funding,
  dataComponent: propTypes.dataComponent,
  performAfterCreatePayment: PropTypes.func,
  timezone: PropTypes.string,
};

export default StatusForm;
